import * as actionTypes from '../../../constants';

export function onChangeLanguage(payload, cb) {
    cb && cb(payload.language)
    return {
        type: actionTypes.ON_CHANGE_TRANSLATION_LANGUAGE,
        payload
    };
};